module.exports = __webpack_public_path__ + "static/media/img-4114@3x.f31e88e4.png";